var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 62,
    viewBox: "0 0 66 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0098 39.1479C64.827 35.3753 63.1732 32.5262 60.0852 30.6737C57.4044 29.0654 54.015 28.472 51.0532 28.1035C48.4285 27.7771 46.449 25.542 46.449 22.9043C46.449 10.6478 36.4481 0.67627 24.1549 0.67627H22.869C10.5759 0.67627 0.574951 10.6477 0.574951 22.9043L0.717829 61.9459H65.0274V39.1479H65.0098ZM55.0237 57.6713H10.7216V49.122H15.0089V54.1091H19.2963V49.122H22.869V54.1091H27.1563V49.122H30.729V54.1091H35.0164V49.122H38.5891V54.1091H42.8764V49.122H46.4491V54.1091H50.7365V49.122H55.0238L55.0237 57.6713Z",
    fill: "#4860AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDown);
export default __webpack_public_path__ + "static/media/top-down.6a8843daadd73480744041a5d4f979db.svg";
export { ForwardRef as ReactComponent };